module.exports = __webpack_public_path__ + "img/logo_discord.bdcc8eaa.svg";